module.exports = __webpack_public_path__ + "static/media/kolorowanka_5.608848af.png";